export { default } from './People'
